const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/grade?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async fetchListPosition({ commit }, { search }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/grade/position?search=${search}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  updatePosition({ commit }, payload) {
    return window.axios.put(`/api/grade/position`, payload.data);
  },
  // eslint-disable-next-line no-unused-vars
  async fetchDetail({ commit }, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/grade/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  save({ rootGetters }, payload) {
    const schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.post('/api/grade', { ...payload, schoolId });
  },

  update({ rootGetters }, payload) {
    const schoolId = rootGetters['Auth/currentSchool'];
    return window.axios.put(`/api/grade/${payload.id}`, { ...payload, schoolId });
  },

  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/grade/${payload.gradeId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
